import request from "@utils/request";

/**
 * 获取售后数据
 * @param id
 * @returns {*}
 */
export function getAftersaleData(id){
    return request.get("/eb/order/aftersale/getAftersaleData?id="+id);
}

/**
 * 更改售后任务状态
 * @param id
 * @returns {*}
 */
 export function changeStatus(data){
    return request.post("/eb/order/aftersale/task/updateStatus",data);
}

/**
 * 确认退款
 * @param data
 * @returns {*}
 */
export function saveConfirmRefundMoney(data){
    return request.post("/eb/order/aftersale/saveConfirmRefundMoney",data);
}

/**
 * 售后保存
 * @param data
 * @returns {*}
 */
export function aditSave(data,repeatFlag){
    return request.post("/eb/order/aftersale/aditSave?repeatFlag="+repeatFlag,data);
}

/**
 * 保存价格
 * @param data
 * @returns {*}
 */
export function saveChangePrice(data){
    return request.post("/eb/order/saveChangePrice",data);
}

/**
 * 保存发货记录
 * @param data
 * @returns {*}
 */
 export function saveSendRecord(data){
    return request.post("/eb/order/send/saveRecord",data);
}


/**
 * 获取发货记录
 * @param data
 * @returns {*}
 */
 export function getOrderSend(data){
    return request.get("/eb/order/send/getOrderSend?orderId="+data);
}


/**
 * 获取待发货产品列表
 * @param data
 * @returns {*}
 */
 export function getNeedSendProduct(data){
    return request.get("/eb/order/send/getNeedSendProduct?orderId="+data);
}

/**
 * 更改团购任务状态
 * @param id
 * @returns {*}
 */
export function changeDiyStatus(data){
    return request.post("/eb/diy/updateStatus",data);
}